'use strict'

import { ParseError } from './puzzle.js'
import { Crossword } from './crossword.js'
import { Cell, Clue, Grid } from './grid.js'

export class PaJson extends Crossword {
  constructor (data = new ArrayBuffer()) {
    super(data)
  }

  // Very, very basic JSONAPI parsing.
  _parsePuzzle () {
    this._data = JSON.parse(
      String.fromCharCode.apply(
        null, new Uint8Array(this._data)
      )
    )

    const attrs = this._data['data']['attributes']

    this.id = this._data['data']['id']
    this.title = attrs['name']
    this.date = attrs['created_at']
    this.grid.height = attrs['size']['height']
    this.grid.width = attrs['size']['width']
    this.types = attrs['puzzle_types'].join(',')
    this._puzzle_answers = attrs['puzzle_answers']

    for (let attr of [
      'author', 'copyright', 'notes',
      'checksum', 'solution'
    ]) {
      this[attr] = attrs[attr]
    }

    // Assign advanced puzzle data.
    this._setCells()
    this._setClues()
  }

  // Sets the cell numbers for the cells in the grid.
  _setCellNumbers () {
    let cell

    let i

    let len = this.grid.cells.length

    let num = 1

    let x

    let y

    for (i = 0; i < len; i++) {
      let across, down

      cell = this.grid.cells[i]
      x = cell.x
      y = cell.y

      // Ignore cell if it doesn't have an answer.
      if (!this.grid.cellHasAnswer(x, y)) { continue }

      // Check if the current cell starts an across clue.
      if (
        (x == 0 || this.grid.cellIsNullOrBlock(x - 1, y)) &&
        (x + 1 < this.grid.width) &&
        this.grid.cellHasAnswer(x + 1, y)
      ) {
        across = true
      }

      // Check if the current cell starts a down clue.
      if (
        (y == 0 || this.grid.cellIsNullOrBlock(x, y - 1)) &&
        (y + 1 < this.grid.height) &&
        this.grid.cellHasAnswer(x, y + 1)
      ) {
        down = true
      }

      // Set the clue number to the current cell, if necessary.
      if (down || across) {
        this.grid.cells[i].cellNumber = num
        if (across) { this.grid.cells[i].axes.push('across') }
        if (down) { this.grid.cells[i].axes.push('down') }

        num += 1
      }
    }
  }

  _setCells () {
    let cell; let idx; let isBlock

    let isMaxX; let x = 0; let y = 0

    this.solution.split('').map((answer, i) => {
      isBlock = this._isBlockChr(answer)
      cell = new Cell({
        answer: isBlock ? null : answer.toUpperCase(),
        cellType: isBlock ? 'block' : null,
        idx: i,
        x: x,
        y: y
      })

      isMaxX = x >= (this.grid.width - 1)
      y = isMaxX ? (y + 1) : y
      x = isMaxX ? 0 : (x + 1)

      this.grid.cells.push(cell)
    })

    this._setCellNumbers()
  }

  _setClues () {
    let cell_clue, clue

    this._puzzle_answers.forEach(puzzle_answer => {
      clue = puzzle_answer['attributes']

      cell_clue = new Clue({
        'axis': (clue.axis ? 'down' : 'across'),
        'clue_string': clue.clue,
        'idx': clue.index,
        'clue_number': this.grid.cells[clue.index].cellNumber,
        'x': clue.x,
        'y': clue.y
      })

      this.grid.cells[cell_clue.idx].clues.push(cell_clue)
      this.clues.push(cell_clue)
    })

    this._setClueCells()
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/lib/pa_json.js
// module id = 237
// module chunks = 0